import { Skeleton } from '@/components/ui/Skeleton'

/**
 * 작업 목록 로딩 스켈레톤.
 * 행 높이를 실제 standard 뷰 행(가상화 estimateSize 72px)과 맞춰
 * 콘텐츠 교체 시 레이아웃 시프트를 최소화한다.
 */
export function TaskListSkeleton() {
  return (
    <div className="space-y-3 mt-1" aria-label="작업 목록 로딩 중" role="status">
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-3 p-3 h-[72px] rounded-xl border border-base bg-surface-primary"
        >
          <Skeleton variant="circular" width={24} height={24} animation="wave" />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width={`${70 - i * 8}%`} height={14} animation="wave" />
            <Skeleton variant="text" width={80} height={10} animation="wave" />
          </div>
          <Skeleton variant="rectangular" width={16} height={16} animation="wave" />
        </div>
      ))}
    </div>
  )
}
